// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3gnHC","title":"ClientInsurance_title__6CgHx","itemText":"ClientInsurance_itemText__1_7bY"};